import { z } from 'zod';

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'メールアドレスを入力してください。')
    .pipe(z.string().email('有効なメールアドレスを入力してください。')),
  password: z.string().min(1, 'パスワードを入力してください。'),
});

export type LoginFormFieldValues = z.infer<typeof loginSchema>;
